import { Component } from '@angular/core';

@Component({
  selector: 'stars-anatomy-features',
  templateUrl: './anatomy-features.html',
  styleUrls: ['./anatomy-features.scss']
})
export class AnatomyFeaturesComponent {}
